"use client"

import { createContext, useContext, useState, useEffect } from "react"

// Define translations
const translations = {
  en: {
    "ETref Weather Dashboard": "ETref Weather Dashboard",
    "ETref Calculator": "ETref Calculator",
    "View Weather": "View Weather",
    "Loading weather data...": "Loading weather data...",
    "Need to calculate ETref?": "Need to calculate ETref?",
    "Use our advanced ETref calculator with the current weather data":
      "Use our advanced ETref calculator with the current weather data",
    "Open ETref Calculator": "Open ETref Calculator",
    "Back to Weather": "Back to Weather",
    "Current weather": "Current weather",
    "Feels like": "Feels like",
    "Wind": "Wind",
    "Humidity": "Humidity",
    "Visibility": "Visibility",
    "Pressure": "Pressure",
    "Dew point": "Dew point",
    "Air quality": "Air quality",
    "Daily Forecast": "Daily Forecast",
    "Hourly Forecast": "Hourly Forecast",
    "Today": "Today",
    "Tomorrow": "Tomorrow",
    "Weather Map": "Weather Map",
    "Loading map...": "Loading map...",
    "Thunderstorm - Severe": "Thunderstorm - Severe",
    "Select Location": "Select Location",
    "Select from Map": "Select from Map",
    "Country": "Country",
    "District": "District",
    "Select an option": "Select an option",
    "Failed to fetch countries": "Failed to fetch countries",
    "Failed to fetch districts": "Failed to fetch districts",
    "Failed to fetch weather data": "Failed to fetch weather data",
    "Failed to load map": "Failed to load map",
    "Login": "Login",
    "Sign in to your account": "Sign in to your account",
    "Email Address": "Email Address",
    "Password": "Password",
    "Master Data Management": "Master Data Management",

    // Add more translations as needed
  },
  ar: {
    "ETref Weather Dashboard": "لوحة معلومات الطقس ETref",
    "ETref Calculator": "حاسبة ETref",
    "View Weather": "عرض الطقس",
    "Loading weather data...": "جاري تحميل بيانات الطقس...",
    "Need to calculate ETref?": "هل تحتاج إلى حساب ETref؟",
    "Use our advanced ETref calculator with the current weather data":
      "استخدم حاسبة ETref المتقدمة مع بيانات الطقس الحالية",
    "Open ETref Calculator": "فتح حاسبة ETref",
    "Back to Weather": "العودة إلى الطقس",
    "Current weather": "الطقس الحالي",
    "Feels like": "يشعر وكأنه",
    "Wind": "الرياح",
    "Humidity": "الرطوبة",
    "Visibility": "الرؤية",
    "Pressure": "الضغط",
    "Dew point": "نقطة الندى",
    "Air quality": "جودة الهواء",
    "Daily Forecast": "التوقعات اليومية",
    "Hourly Forecast": "التوقعات بالساعة",
    "Today": "اليوم",
    "Tomorrow": "غدا",
    "Weather Map": "خريطة الطقس",
    "Loading map...": "جاري تحميل الخريطة...",
    "Thunderstorm - Severe": "عاصفة رعدية - شديدة",
    "Select Location": "اختر الموقع",
    "Select from Map": "اختر من الخريطة",
    "Country": "البلد",
    "District": "المنطقة",
    "Select an option": "اختر خيارًا",
    "Failed to fetch countries": "فشل في جلب البلدان",
    "Failed to fetch districts": "فشل في جلب المناطق",
    "Failed to fetch weather data": "فشل في جلب بيانات الطقس",
    "Failed to load map": "فشل في تحميل الخريطة",
    "Login": "تسجيل الدخول",
    "Sign in to your account": "تسجيل الدخول إلى حسابك",
    "Email Address": "عنوان البريد الإلكتروني",
    "Password": "كلمة المرور",
    "Master Data Management": "إدارة البيانات الرئيسية",
    "Reference Evapotranspiration Calculator": "حاسبة التبخر النتحي المرجعي",
    "Calculate WATref using different models and weather data": "احسب ETref باستخدام نماذج وبيانات طقس مختلفة",
    "Meteorological Data": "البيانات الجوية",
    "Upload Weather Data": "تحميل بيانات الطقس",
    "ETref Calculation Models": "نماذج حساب ETref",
    "A web-based platform to calculate water requirement for irrigation using reference evapotranspiration (ETref) models.": "منصة على الإنترنت لحساب احتياجات المياه للري باستخدام نماذج التبخر النتحي المرجعي (ETref).",
    "Welcome" : "مرحبًا",
    "My Farms": "مزارعي",
    "View Farms": "عرض المزارع",
    "Add Farm": "إضافة مزرعة",
    "My Fields": "حقولي",
    "View Fields": "عرض الحقول",
    "Add Field": "إضافة حقل",
    "My Parameter Stations": "محطات المعلمات الخاصة بي",
    "View Parameter Stations": "عرض محطات المعلمات",
    "Add Parameter Station": "إضافة محطة معلمات",
    "View Stations": "عرض المحطات",
    "Add Station": "إضافة محطة",
    "Recent Calculations": "الحسابات الأخيرة",
    "View Calculations": "عرض الحسابات",
    "View All": "عرض الكل",
    "ETref Models": "نماذج ETref",
    "Select ETref Model(s)": "اختر نموذج ETref",
    "General Penman-Monteith Model": "نموذج بنمان-مونتيث العام",
    "hcref [m]": "hcref [م]",
    "Tall Crop (Alfalfa)": "محصول طويل (الفافا)",
    "Short Crop (Grass)": "محصول قصير (عشب)",
    "Crop Height [m]": "ارتفاع المحصول [م]",
    "Crop Coefficient (Kc)": "معامل المحصول (Kc)",
    "Crop Type": "نوع المحصول",
    "Soil Type": "نوع التربة",
    "Field Name": "اسم الحقل",
    "Select Farm": "اختر مزرعة",
    "Field Details": "تفاصيل الحقل",
    "Farm Selection": "اختيار المزرعة",
    "Field Selection": "اختيار الحقل",
    "Crop Selection": "اختيار المحصول",
    "Quick Actions": "إجراءات سريعة",
    "Calculate WATref": "احسب ETref",
    "Add Farm": "إضافة مزرعة",
    "New Field": "حقل جديد",
    "Weather Parameter Device": "بيانات الجهاز",
    "Update Profile": "تحديث الملف الشخصي",
    "Manage Station": "إدارة المحطة",
    // Add more translations as needed
  },
}

const LanguageContext = createContext()

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState("en")
  const [direction, setDirection] = useState("ltr")

  useEffect(() => {
    // Set direction based on language
    setDirection(language === "ar" ? "rtl" : "ltr")

    // Set HTML dir attribute
    document.documentElement.setAttribute("dir", language === "ar" ? "rtl" : "ltr")

    // You could also set lang attribute
    document.documentElement.setAttribute("lang", language)
  }, [language])

  const changeLanguage = (lang) => {
    setLanguage(lang)
  }

  // Translation function
  const t = (key) => {
    return translations[language][key] || key
  }

  return (
    <LanguageContext.Provider value={{ language, changeLanguage, t, direction }}>{children}</LanguageContext.Provider>
  )
}

export const useLanguage = () => useContext(LanguageContext)
